export default {
    APPLY(state) {
        state.is_applied = true;
        state.is_apply_complete = true;
    },

    STORE_APPLY_UUID(state, applyUuid) {
        state.apply_uuid = applyUuid;
    },

    STORE_APPLY_AS_EXISTING_USER(state) {
        state.application_type = 'existing_user';
    },

    STORE_APPLY_AS_NEW_USER(state) {
        state.application_type = 'new_user';
    },

    STORE_APPLY_AS_GUEST_USER(state) {
        state.application_type = 'guest_user';
    },

    STORE_APPLY_STEP(state, step) {
        state.apply_step = step;
    },

    STORE_APPLY_STEPS_COUNT(state, count) {
        state.apply_steps_count = count;
    },

    STORE_APPLY_USER(state, data) {
        state.user[data.key] = data.value;
    },

    STORE_USER(state, user) {
        state.user = user;
    },

    CHECK_RESUME_DEFAULT(state) {
        state.make_resume_default = true;
    },

    UNCHECK_RESUME_DEFAULT(state) {
        state.make_resume_default = false;
    },

    OPEN_APPLY_FORM(state) {
        state.is_apply_form_open = true;
        state.is_applied = false;
    },

    CLOSE_APPLY_FORM(state) {
        state.is_apply_form_open = false;
    },

    RESET_APPLY(state) {
        state.user = {};
        state.apply_uuid = '';
        state.apply_step = 1;
        state.is_applied = false;
        state.is_apply_form_open = false;
        state.is_apply_complete = false;
        state.application_type = {};
    },
};
